import { CultureInfo } from '../culture-info.model';
import { CultureInfoPt } from './pt';

/**
 * @ignore
 */
export const CultureInfoPtBR: CultureInfo = {
  name: 'pt-BR',
  displayName: 'Portuguese (Brazil)',
  iso3LanguageCode: 'por',
  iso2LanguageCode: 'pt',
  ietfLanguageTag: 'pt-BR',
  parent: CultureInfoPt
};
